import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Icon } from "../../Icon/Icon/Icon";
import { Image } from "../../Image/Image/Image";
import { Text } from "../../Text/Text/Text";
import Utility from "../../Utility/Utility";
import styles from "./VideoGridItem.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VideoGridItem = function VideoGridItem(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$playing = _ref.playing,
    playing = _ref$playing === void 0 ? false : _ref$playing,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    thumbnail = _ref.thumbnail,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0 : _ref$duration,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$cardActionAttrib = _ref.cardActionAttributes,
    cardActionAttributes = _ref$cardActionAttrib === void 0 ? {} : _ref$cardActionAttrib;
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: classnames({
      [className]: true,
      [styles.videoGridItem]: true,
      [styles.videoGridItemPlaying]: playing
    }),
    onClick: onClick,
    type: "button"
  }, cardActionAttributes), {}, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.videoGridItemThumbnailWrapper,
      children: [/*#__PURE__*/_jsx(Image, {
        alt: "video thumbnail",
        className: styles.videoGridItemThumbnail,
        src: thumbnail,
        transformations: {
          image1x: {
            width: 392
          },
          image2x: {
            width: 784
          }
        }
      }), /*#__PURE__*/_jsx("span", {
        className: styles.videoGridItemDuration,
        children: Utility.getDurationFromMs(duration)
      }), /*#__PURE__*/_jsx("div", {
        className: styles.videoGridItemPlay,
        children: /*#__PURE__*/_jsx(Icon, {
          className: styles.videoGridItemPlayIcon,
          type: "play-alt-rounded"
        })
      })]
    }), title && /*#__PURE__*/_jsx("div", {
      className: styles.videoGridItemTitle,
      children: /*#__PURE__*/_jsx(Text, {
        typog: "headline7",
        children: title
      })
    })]
  }));
};